(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var burger = document.getElementById('HeroBurger');
  var drawer = document.getElementById('HeroDrawer');
  if (!burger || !drawer) return;
  var overlay = drawer.querySelector('.hero__drawer-overlay');
  var closeBtn = drawer.querySelector('.hero__drawer-close');
  var links = drawer.querySelectorAll('.hero__drawer-link');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  links.forEach(function (link) { link.addEventListener('click', closeDrawer); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var burger = document.getElementById('SiteHeaderBurger');
    var drawer = document.getElementById('SiteHeaderDrawer');
    if (! burger || ! drawer) return;
    


    var overlay = drawer.querySelector('.site-header__drawer-overlay');
    var closeBtn = drawer.querySelector('.site-header__drawer-close');
    var links = drawer.querySelectorAll('.site-header__drawer-link');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    burger.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    links.forEach(function(link) {
      link.addEventListener('click', closeDrawer);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
